import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  extractErrorMessage(error: HttpErrorResponse): string {
    const payload = error.error as any;

    if (payload?.error?.error) {
      return payload.error.error;
    }

    // Handle validation errors from the errors field
    if (payload?.errors && typeof payload.errors === 'object') {
      const errorMessages = Object.values(payload.errors).flat();
      if (errorMessages.length > 0) {
        return errorMessages.join('\n');
      }
    }

    if (payload?.status?.message) {
      const msg = payload.status.message;
      if (typeof msg === 'object') {
        return Object.values(msg).flat().join('\n');
      }
      return msg;
    }

    return 'An unexpected error occurred.';
  }
}
